module.exports = __webpack_public_path__ + "img/no_photo.693608c4.png";